import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
const CreaMarca = () => {
  const [postNombre, setPostNombre] = useState([]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/CreaMarca",
      data: {
        marca: postNombre,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert(" creada con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };
  return (
    <>
      {/* Page content */}
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Nueva
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <br></br> <br></br>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">Marcas</h6>
                    {/* Description */}
                    <div className="pl-lg-4">
                      <FormGroup>
                        <Input
                          className="form-control-alternative"
                          id="input-postal-code"
                          placeholder="Nombre de la marca"
                          type="text"
                          onChange={(e) => setPostNombre(e.target.value)}
                        />
                      </FormGroup>
                      <button
                        className="btn btn-primary btn-lg"
                        color="primary"
                        onClick={postData}
                      >
                        ENVIAR
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CreaMarca;
